"use client";

import { useEffect } from "react";

// The root layout sets <html lang="ro"> for the whole site. The few English
// pages correct it after mount (Bing weighs the attribute; Google infers
// language from content) and restore it on client-side navigation away.
export default function HtmlLang({ lang }: { lang: string }) {
  useEffect(() => {
    const previous = document.documentElement.lang;
    document.documentElement.lang = lang;
    return () => {
      document.documentElement.lang = previous;
    };
  }, [lang]);
  return null;
}
